<div class="image" fxLayout="column" fxLayoutAlign="center center" [style.background-image]="'url(' + loginBackgroundImageUrl + ')'"></div>

<div class="card glemtkodeordForm">
    <div class="title backgroundcolor1" [class.login-title--branded]="!!loginBrandImageUrl()">
        @if (technicianLogin) {
            @if (loginBrandImageUrl()) {
                <h1 class="center login-brand-image-wrap">
                    <img class="login-brand-image" [src]="loginBrandImageUrl()" alt="Forsyning|ServicePro" />
                </h1>
            } @else {
                <h1 class="center login-brand login-brand--servicepro">
                    <span class="login-brand__prefix">Forsyning</span><span class="login-brand__separator">|</span>ServicePro
                </h1>
            }
        } @else {
            @if (overskrift$ | async; as overskrift) {
                <h1>{{ overskrift }}</h1>
            } @else {
                <h1 class="center">E<span>|</span>Forsyning</h1>
            }
        }
        @if (!loginBrandImageUrl() && titel) {
            <h2>{{ titel }}</h2>
        }
        @if (!technicianLogin) {
            <button mat-button class="button-back backgroundcolor1" (click)="onSkiftForsyningClick()" role="button" type="button" aria-label="Skift forsyning">
                Skift forsyning
            </button>
        }
    </div>
    <div class="content">
        @if (arbejder) {
            <mat-spinner class="mat-spinner"></mat-spinner>
        }
        <ng-content></ng-content>
    </div>
    <div class="footer" fxLayout="row wrap" fxLayoutGap="5px grid" fxLayoutAlign="center center">
        <ng-content select="[login-footer]"></ng-content>
    </div>
</div>
